module.exports = __webpack_public_path__ + "static/media/mobile-dev.ad3dfdd1.jpg";